const DAY_BITS = [1, 2, 4, 8, 16, 32, 64];
const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const decodeDays = (workDays) => {
  const arr = Array.isArray(workDays) ? workDays : [];
  return DAY_BITS.filter((b) => arr.includes(b))
    .map((b) => DAY_LABELS[Math.log2(b)])
    .join(", ");
};

export const ShiftsColumn = ({ shifts = [], onClick }) => (
  <div onClick={onClick} className={onClick ? "cursor-pointer" : ""}>
    {shifts.map((s, i) => (
      <div key={i} className="small">
        <span className="fw-medium">{decodeDays(s.workDays)}</span>
        {" · "}
        <span className="text-muted">
          {s.startTime} – {s.endTime}
        </span>
      </div>
    ))}
  </div>
);
